import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const resetPasswordValidationSchema = yup.object({
  newPassword: Schema.password,
  confirmationPassword: Schema.repeatPassword,
});
